



















import { Component, Vue, Prop } from 'vue-property-decorator';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import Dialog from '@/components/Dialog.vue';

@Component({
  components: {Dialog, ConfirmButton, CancelButton},
})
export default class AddDeviceModel extends Vue {
  @Prop() private isDeviceModelDialogVisible!: boolean;
  @Prop() private manufacturerId!: any;

  private deviceModel: any = {
    name: '',
    manufacturer_id: null,
  };

  public mounted() {
    this.deviceModel.manufacturer_id = this.manufacturerId;
  }

  private async save() {
    await AdminDeviceTypeService.addDeviceModel(this.deviceModel);
    this.$emit('close');
  }
}
